import map from "../assets/map.png";
import React, { useMemo, useState } from "react";

/** Calibrated base size (must keep same aspect ratio when you render) */
const BASE_W = 666;
const BASE_H = 375;

/** Homography H mapping [lon,lat,1]^T -> [x,y,1]^T (for 666×375) */
const H = [
  [-8.42084278, -46.04458495, 1873.53632376],
  [-21.46568457, -24.84197570, 1497.29750290],
  [-0.09047217, -0.05667532, 5.47508561],
];

function lonLatToPixel(lon, lat) {
  const x = H[0][0] * lon + H[0][1] * lat + H[0][2];
  const y = H[1][0] * lon + H[1][1] * lat + H[1][2];
  const w = H[2][0] * lon + H[2][1] * lat + H[2][2];
  return [x / w, y / w];
}
/** Percentage position within the container, independent of its rendered pixel size */
function projectPercent(lon, lat) {
  const [x0, y0] = lonLatToPixel(lon, lat);
  return [(x0 / BASE_W) * 100, (y0 / BASE_H) * 100];
}

/** ---------- Five static locations (edit/extend as you wish) ---------- */
const STATIC_LOCATIONS = [
  { id: 4, name: "الاسماعيلية", lon: 33.7187, lat: 30.5001, title: true },
  { id: 5, name: "السويس", lon: 33.7357, lat: 29.7200, title: true },
  { id: 7, name: "الشرابية", lon: 31.8000, lat: 30.7000, title: false },
  { id: 9, name: "الشرقية", lon: 32.9000, lat: 30.7000, title: false },
  { id: 8, name: "بولاق", lon: 32.5000, lat: 30.0000, title: true },
  { id: 32, name: "محلة محروم", lon: 31.5000, lat: 31.0000, title: true },
  { id: 44, name: "الحضرة", lon: 30.5000, lat: 31.8000, title: true },
  { id: 46, name: "شرق", lon: 30.7000, lat: 31.9000, title: true },
  { id: 25, name: "حوش عيسي", lon: 30.7000, lat: 31.2000, title: true },
  { id: 41, name: "المنيا", lon: 31.5000, lat: 28.4000, title: true },
  { id: 43, name: "اشمون", lon: 32.0000, lat: 30.7000, title: false },
  { id: 45, name: "الهانوفيل", lon: 29.0000, lat: 32.0000, title: true },
  { id: 31, name: "فوه", lon: 32.0000, lat: 31.5000, title: true },
  { id: 19, name: "شرق النيل", lon: 32.0000, lat: 29.4000, title: true },
  { id: 47, name: "محرم بك", lon: 31.0000, lat: 31.7000, title: false },
  { id: 27, name: "الخانكة", lon: 31.9000, lat: 30.8000, title: false },
  { id: 17, name: "دمياط الجديدة", lon: 32.9000, lat: 31.0000, title: false },
  { id: 16, name: "الخارجة", lon: 22.0000, lat: 22.0000, title: false },
  { id: 18, name: "الصيادين", lon: 32.5000, lat: 30.8000, title: false },
  { id: 20, name: "الطود", lon: 33.5000, lat: 25.0000, title: false },
  { id: 21, name: "العريش", lon: 34.5000, lat: 30.3000, title: false },
  { id: 22, name: "بئر العبد", lon: 34.0000, lat: 30.6000, title: false },
  { id: 23, name: "الشيخ زويد", lon: 34.6000, lat: 30.3000, title: false },
  { id: 24, name: "الطور", lon: 34.5000, lat: 28.5000, title: false },
  { id: 26, name: "بورسعيد", lon: 33.2000, lat: 30.9000, title: false },
  { id: 28, name: "بلتان", lon: 32.0000, lat: 30.9000, title: false },
  { id: 29, name: "فقط", lon: 31.9000, lat: 30.8000, title: false },
  { id: 30, name: "بني غالب", lon: 31.4000, lat: 27.5000, title: true },
  { id: 33, name: "ك7", lon: 28.0000, lat: 32.3000, title: true },
  { id: 34, name: "الكوثر", lon: 32.4000, lat: 26.5000, title: true },
  { id: 35, name: "طهطا", lon: 32.5000, lat: 26.5000, title: true },
  { id: 36, name: "سوهاج", lon: 32.6000, lat: 26.5000, title: true },
  { id: 37, name: "السنبلاوين", lon: 33.0000, lat: 31.1000, title: false },
  { id: 38, name: "ميت غمر", lon: 33.1000, lat: 31.0000, title: false },
  { id: 39, name: "اجا", lon: 33.2000, lat: 30.9000, title: false },
  { id: 40, name: "المنزلة", lon: 33.3000, lat: 30.8000, title: false },
  { id: 42, name: "اسوان", lon: 34.0000, lat: 24.4000, title: true },
  { id: 48, name: "المنشية", lon: 32.6000, lat: 30.1000, title: true },
  { id: 14, name: "wabys vtc", lon: 32.5000, lat: 30.0000, title: true },
  { id: 1, name: "Badr", lon: 31.8000, lat: 30.7000, title: false },
  { id: 2, name: "Damietta", lon: 32.5000, lat: 30.0000, title: true },
  { id: 15, name: "مركز شبرا للصناعات النسيجية و الهندسية", lon: 32.5000, lat: 30.0000, title: true },
  { id: 49, name: "مركز معادن شبرا الخيمة", lon: 32.5000, lat: 29.2000, title: true },
  { id: 52, name: "مركز مشترك العباسية", lon: 32.0000, lat: 28.4000, title: true },
  { id: 53, name: "مركز مشترك المظلات", lon: 32.0000, lat: 29.4000, title: true },
  { id: 55, name: "مركز الاميرية التجريبي", lon: 30.9000, lat: 30.4000, title: true },
  { id: 56, name: "مركز الالات الدقيقة سمارت للحاسبات والالكترونيات", lon: 31.0000, lat: 29.4000, title: true },
  { id: 57, name: "5D", lon: 32.0000, lat: 30.9000, title: true },
  { id: 58, name: "WABYS Collage", lon: 32.0000, lat: 30.4000, title: true },
];
// id -> location lookup
const ID_INDEX = Object.fromEntries(STATIC_LOCATIONS.map(p => [p.id, p]));

/** Marker (image or dot) */
function Marker({
  xPercent,
  yPercent,
  title,
  markerSrc,
  markerSize = 16,
  anchor = "center",
  onMouseEnter,
  onMouseLeave,
  handleSelectOrganization
}) {
  const w = markerSize, h = markerSize;
  const style =
    anchor === "bottom"
      ? { left: `calc(${xPercent}% - ${w / 2}px)`, top: `calc(${yPercent}% - ${h}px)` }
      : { left: `calc(${xPercent}% - ${w / 2}px)`, top: `calc(${yPercent}% - ${h / 2}px)` };

  return (
    <img
      src={markerSrc}
      alt={title}
      onClick={() => handleSelectOrganization(title)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        position: "absolute",
        width: w,
        height: h,
        objectFit: "contain",
        cursor: "pointer",
        ...style,
      }}
    />
  );
}

/** --------- Map component driven by `ids` from the parent --------- */
const Egypt = ({
  width = BASE_W,
  height = BASE_H,
  ids = [],                 // string | string[]  (e.g., "cairo" or ["alex","cairo"])
  showLabels = true,
  markerSrc,                // e.g., import pin from "../assets/pin.png"
  markerSize = 16,
  markerAnchor = "center",  // or "bottom" if your pin tip should touch the point
  handleSelectOrganization
}) => {
  // Normalize ids -> selected fixed locations
  const [hoveredId, setHoveredId] = useState(null);
  const selected = useMemo(() => {
    const list = Array.isArray(ids) ? ids : (ids ? [ids] : []);
    return list
      .map(id => {
        const p = ID_INDEX[id];
        if (!p) {
          console.warn(`[Egypt] Unknown id: "${id}"`);
          return null;
        }
        return p;
      })
      .filter(Boolean);
  }, [ids]);

  // Project to percentage positions, independent of the rendered pixel size
  const placed = useMemo(() => {
    return selected.map(p => {
      const [xPercent, yPercent] = projectPercent(p.lon, p.lat);
      return { ...p, xPercent, yPercent };
    });
  }, [selected]);

  return (
    <div
      style={{
        position: "relative",
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
        backgroundImage: `url(${map})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        overflow: "hidden",
      }}
    >
      {placed.map(p => (
        <React.Fragment key={p.id}>
          <Marker
            xPercent={p.xPercent}
            yPercent={p.yPercent}
            title={p.name}
            markerSrc={markerSrc}
            markerSize={markerSize}
            anchor={markerAnchor}
            onMouseEnter={() => setHoveredId(p.id)}
            onMouseLeave={() => setHoveredId(null)}
            handleSelectOrganization={handleSelectOrganization}
          />

          {hoveredId === p.id && (
            <div
              style={{
                position: "absolute",
                left: p.title
                  ? `calc(${p.xPercent}% + ${p.id === 4 ? 25 : 8}px)`
                  : `calc(${p.xPercent}% - 60px)`,
                top: `calc(${p.yPercent}% - 6px)`,
                padding: "2px 6px",
                borderRadius: 6,
                background: "rgba(0,0,0,0.7)",
                color: "white",
                fontSize: 12,
                whiteSpace: "nowrap",
                pointerEvents: "none",
              }}
            >
              {p.name}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Egypt;